import { Component } from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'app-unauthorized-layout',
  imports: [RouterOutlet],
  templateUrl: './unauthorized-layout.html',
  styleUrl: './unauthorized-layout.css'
})
export class UnauthorizedLayoutComponent {

}
